import { render, staticRenderFns } from "./AddEditZone.vue?vue&type=template&id=84c26a4a&scoped=true&"
import script from "./AddEditZone.vue?vue&type=script&lang=js&"
export * from "./AddEditZone.vue?vue&type=script&lang=js&"
import style0 from "./AddEditZone.vue?vue&type=style&index=0&id=84c26a4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c26a4a",
  null
  
)

export default component.exports